module.exports = __webpack_public_path__ + "static/media/JodyStephenAvatar.7dc03a6b.png";